import axios from 'axios'
import { getHeaders } from 'Modules/util'
import { GET_ORDER as GET_CREDITOR_ORDER } from 'Modules/loanOrders/creditor'

const url = process.env.REACT_APP_API

export const GET_LIST = 'loanOrders/chargeAmortization/GET_LIST'
export const DELETE_ORDER = 'loanOrders/chargeAmortization/DELETE_ORDER'
export const CREATE_ORDER = 'loanOrders/chargeAmortization/CREATE_ORDER'
export const GET_ORDER = 'loanOrders/chargeAmortization/CREATE_ORDER'
export const UPDATE_ORDER = 'loanOrders/chargeAmortization/UPDATE_ORDER'
export const GET_RELATED_ORDERS = 'loanOrders/chargeAmortization/GET_RELATED_ORDERS'
export const AUTHORIZE_ORDER = 'loanOrders/chargeAmortization/AUTHORIZE_ORDER'
export const IS_FETCHING_CHARGE_AMORTIZATION = 'loanOrders/chargeAmortization/IS_FETCHING_CHARGE_AMORTIZATION'
export const IS_FETCHING_CHARGE_AMORTIZATION_COMPLETE = 'loanOrders/chargeAmortization/IS_FETCHING_CHARGE_AMORTIZATION_COMPLETE'
export const END_ORDER_EDIT = 'loanOrders/chargeAmortization/END_ORDER_EDIT'


const initialState = {
  list: {
    data: []
  },
  isFetchingChargeAmortization: false,
  relatedOrders: [],
  order: undefined,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER:
    case UPDATE_ORDER:
    case CREATE_ORDER:
    case GET_RELATED_ORDERS:
    case GET_LIST:
      return { ...state, ...action.payload }
    case AUTHORIZE_ORDER:
      return { ...state, order: { ...state.order, ...action.payload } }
    case DELETE_ORDER:
      const { data, ...meta } = state.list
      return { ...state, list: { data: data.filter(it => it.id !== action.payload), ...meta, last_page: Math.ceil(data.length / meta.per_page) } }
    case IS_FETCHING_CHARGE_AMORTIZATION:
      return { ...state, isFetchingChargeAmortization: true }
    case IS_FETCHING_CHARGE_AMORTIZATION_COMPLETE:
      return { ...state, isFetchingChargeAmortization: false }
    case END_ORDER_EDIT:
      return initialState
    default:
      return state
  }
}

export const isFetchingChargeAmortization = () => ({
  type: IS_FETCHING_CHARGE_AMORTIZATION
})

export const isFetchingChargeAmortizationComplete = () => ({
  type: IS_FETCHING_CHARGE_AMORTIZATION_COMPLETE
})

export const getList = (params) => {
  const headers = getHeaders()
  return dispatch => {
    dispatch(isFetchingChargeAmortization())
    return axios.post(`${url}/order-loan/collect/list`, params, { headers })
      .then(({ data }) => {
        dispatch(isFetchingChargeAmortizationComplete())
        dispatch({
          type: GET_LIST,
          payload: { list: data }
        })
      })
  }
}

export const deleteOrder = (orderId) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.delete(`${url}/order-loan/collect/${orderId}`, { headers })
      .then(() => {
        dispatch({
          type: DELETE_ORDER,
          payload: orderId,
        })
      })
  }
}

export const createOrder = order => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/order-loan/collect/`, order, { headers })
      .then(({ data }) => {
        dispatch({
          type: CREATE_ORDER,
          payload: { order: data },
        })
        return data
      })
  }
}

export const getOrder = id => {
  const headers = getHeaders()
  return dispatch => {
    return axios.get(`${url}/order-loan/collect/${id}`, { headers })
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER,
          payload: { order: data },
        })
        return data
      })
  }
}

export const getCreditorOrder = id => {
  const headers = getHeaders()
  return dispatch => {
    return axios.get(`${url}/order-loan/collect/send/${id}`, { headers })
      .then(({ data }) => {
        dispatch({
          type: GET_CREDITOR_ORDER,
          payload: { order: data },
        })
        return data
      })
  }
}

export const updateOrder = order => {
  const headers = getHeaders()
  return dispatch => {
    return axios.put(`${url}/order-loan/collect/${order.id}`, order, { headers })
      .then(({ data }) => {
        dispatch({
          type: UPDATE_ORDER,
          payload: { order: data },
        })
        return data
      })
  }
}

export const authorizeOrder = ({ id, ...body }) => {
  const headers = getHeaders()
  return dispatch => {
    return axios.post(`${url}/authorize-order-loan/collect/${id}`, body, { headers })
      .then(({ data }) => {
        dispatch({
          type: AUTHORIZE_ORDER,
          payload: data,
        })
        return data
      })
  }
}

export const endOrderEdit = () => ({ type: END_ORDER_EDIT })


export const getRelatedOrder = () => {
  const headers = getHeaders()
  return dispatch => {
    return axios.get(`${url}/loanOrder/related/list-order-mutual/1`, { headers })
      .then(({ data }) => {
        dispatch({
          type: GET_RELATED_ORDERS,
          payload: { relatedOrders: data },
        })
        return data
      })
  }
}